import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgFile = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 56, height: 56, viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", id: "file_svg_plugin_58077", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Group 2579" }, /* @__PURE__ */ React.createElement("path", { id: "Rectangle 34624807", d: "M4 4C4 1.79086 5.79086 0 8 0H34.3431C35.404 0 36.4214 0.421427 37.1716 1.17157L50.8284 14.8284C51.5786 15.5786 52 16.596 52 17.6569V52C52 54.2091 50.2091 56 48 56H8C5.79086 56 4 54.2091 4 52V4Z", fill: "#B98EFF" }), /* @__PURE__ */ React.createElement("g", { id: "Group 2580" }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_3721_53336", style: {
    maskType: "alpha"
  }, maskUnits: "userSpaceOnUse", x: 4, y: 0, width: 48, height: 56 }, /* @__PURE__ */ React.createElement("path", { id: "Rectangle 34624807_2", d: "M4 4C4 1.79086 5.79086 0 8 0H34.3431C35.404 0 36.4214 0.421427 37.1716 1.17157L50.8284 14.8284C51.5786 15.5786 52 16.596 52 17.6569V52C52 54.2091 50.2091 56 48 56H8C5.79086 56 4 54.2091 4 52V4Z", fill: "#B4D400" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_3721_53336)" }, /* @__PURE__ */ React.createElement("path", { id: "Rectangle 34624807_3", d: "M40 16C37.7909 16 36 14.2091 36 12V0L52 16H40Z", fill: "#CDAFFF" }))), /* @__PURE__ */ React.createElement("g", { id: "Union" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 28C22 30.2091 20.2091 32 18 32C15.7909 32 14 30.2091 14 28C14 25.7909 15.7909 24 18 24C20.2091 24 22 25.7909 22 28ZM17.1161 27.4696C17.0184 27.3719 16.8601 27.3719 16.7625 27.4696L16.409 27.8231C16.3113 27.9208 16.3113 28.0791 16.409 28.1767L17.4696 29.2373C17.5672 29.335 17.7255 29.335 17.8232 29.2373L19.5909 27.4696C19.6886 27.3719 19.6886 27.2137 19.5909 27.116L19.2374 26.7625C19.1398 26.6648 18.9815 26.6648 18.8838 26.7625L17.6464 27.9999L17.1161 27.4696Z", fill: "#F3ECFF" }), /* @__PURE__ */ React.createElement("path", { d: "M26 27C26 26.7239 26.2239 26.5 26.5 26.5H41.5C41.7761 26.5 42 26.7239 42 27V29C42 29.2761 41.7761 29.5 41.5 29.5H26.5C26.2239 29.5 26 29.2761 26 29V27Z", fill: "#F3ECFF" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 40C22 42.2091 20.2091 44 18 44C15.7909 44 14 42.2091 14 40C14 37.7909 15.7909 36 18 36C20.2091 36 22 37.7909 22 40ZM20 40C20 41.1046 19.1046 42 18 42C16.8954 42 16 41.1046 16 40C16 38.8954 16.8954 38 18 38C19.1046 38 20 38.8954 20 40Z", fill: "#F3ECFF" }), /* @__PURE__ */ React.createElement("path", { d: "M26.5 38.5C26.2239 38.5 26 38.7239 26 39V41C26 41.2761 26.2239 41.5 26.5 41.5H41.5C41.7761 41.5 42 41.2761 42 41V39C42 38.7239 41.7761 38.5 41.5 38.5H26.5Z", fill: "#F3ECFF" }))));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgFile;
